import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import { getArtifacts } from "../api";
import * as types from "../consts";

export function* getArtifactsSaga({ payload }: ReturnType<typeof Object>) {
  try {
    const response: AxiosResponse = yield call(getArtifacts, payload);
    if (response) {
      yield put({ type: types.GET_ARTIFACTS_SUCCESS, payload: response.data });
    } else {
      const error = { status: 500, statusText: "Internal Server Error" };
      yield put({ type: types.GET_ARTIFACTS_ERROR, payload: error });
    }
  } catch (error) {
    yield put({ type: types.GET_ARTIFACTS_ERROR, payload: error });
  }
}
